import React from 'react';
import {connect} from 'react-redux';
import {Flex, RemoveItemModal, Jibber} from '/app/src/component';
import style  from './style.css'
import EmployeeSelector from '/app/src/model/Employee/selector';
import EmployeeModel from '/app/src/model/Employee/model'

import {SelectInput} from '/app/src/component/Forms'
import {SVGButton} from '/app/src/component'

class Item extends Jibber{
    constructor(props){
        super(props)

        this.useState({
            screen: 'normal',
            id: props.employee.get('id'),
            confirmRemoval: false,
            updates: {
                role: EmployeeSelector.role(this.props.employee)
            }
        })

        this._renderNormalState = this._renderNormalState.bind(this);
        this._renderEditorState = this._renderEditorState.bind(this);
        this._handleResponseEdit = this._handleResponseEdit.bind(this);

        this._changeRole = this._changeRole.bind(this);
        this._changeView = this._changeView.bind(this);
        this._confirmRemoval = this._confirmRemoval.bind(this);

        this._saveToDatabase = this._saveToDatabase.bind(this);
        this._removeFromDatabase = this._removeFromDatabase.bind(this);
        this.confirmRemovalView = this.confirmRemovalView.bind(this)
    }

    confirmRemovalView(){
        return (
            <RemoveItemModal
                title='Ta bort användare'
                open={this.state.confirmRemoval}
                onClose={()=>{this.setConfirmRemoval(false)}}
                onRemoveClick={this._removeFromDatabase}
                text={<Flex w='100%' center><div> Är du säker på att du vill ta bort <strong>{EmployeeSelector.getName(this.props.employee)}</strong>?</div></Flex>}
            />
        )
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.currentItem !== this.state.id){
            this.setState({
                screen: 'normal',
                id: nextProps.employee.get('id'),
                confirmRemoval: false,
                updates: {
                    role: EmployeeSelector.role(nextProps.employee)
                }
            })
        }
    }

    _changeView(){
        if(this.state.screen === 'normal'){
            this.setState({screen: 'edit'})
        }else{
            this.setState({screen: 'normal'})
        }
    }

    _handleResponseEdit(event){
        this.setState({response: event.target.value})
    }

    _changeRole(e){
        this.setState({updates: {
            ...this.state.updates,
            role: e.target.value
        }})

    }

    _saveToDatabase(){
        this.props.dispatch(EmployeeModel.update(
            this.state.id, this.state.updates.role
        ))

        this.setState({screen: 'normal'})
    }
    _removeFromDatabase(){
        this.props.dispatch(EmployeeModel.delete(
            this.state.id
        ))
        this.setState({screen: 'normal'})
    }
    _confirmRemoval(){
        this.setState({confirmRemoval: !this.state.confirmRemoval})
    }

    _renderNormalState(){
        var focus = this.props.currentItem === this.state.id
        let role;
        switch(this.state.updates.role){
            case 'admin': role = 'Admin'; break;
            case 'manager': role = 'Manager'; break;
            case 'employee':
            default:
            role = 'Employee'; break;
        }

        return (
            <Flex
                width='100%' className={style.Item}
                onClick={this.props._onClick} grow basis='200px'
                backgroundHover='darkwhite'
                borderRadius='60px'
                margin='4px 0px'
                >
                {this.confirmRemovalView()}

                <Flex column grow >
                        <Flex className={style.ItemResponseBody} grow>
                            <Flex vAlignContent='center' hAlignContent='center' marginLeft='20px' marginRight='20px'>
                                <img
                                    alt=''
                                    style={{borderRadius: '50%'}}
                                    width='70px'
                                    height='70px'
                                    src={EmployeeSelector.getImageUrl(this.props.employee)}/>
                            </Flex>
                            <Flex column grow className={style.Info}>
                                <Flex>
                                <Flex basis='80%' hAlignContent='left' className={style.Name} vAlignContent='center' marginTop='20px'>
                                    {EmployeeSelector.getName(this.props.employee)}
                                </Flex>
                                <Flex basis='20%' className={style.Name} vAlignContent='center' marginTop='20px'>
                                    {role}
                                </Flex>
                                </Flex>
                                <Flex grow vAlignContent='bottom' className={style.Email} marginBottom='20px'>
                                {EmployeeSelector.email(this.props.employee)}
                                </Flex>
                            </Flex>

                        </Flex>
                </Flex>
                <Flex hAlignContent='right' basis='70px'>
                    {focus && (
                    <Flex className={style.ItemOptions} column vAlignContent='center' hAlignContent='center'>
                        <SVGButton
                            onClick={this._changeView}
                            src='/images/Edit_M.svg'
                            color='darkgrey'
                            hover='blue'
                            marginLeft='5px'
                            marginBottom='10px'
                        />
                        <SVGButton
                            onClick={() => this._confirmRemoval()}
                            hover='red'
                            src='/images/Trash.svg'
                            color='darkgrey'
                            size='small'
                        />
                    </Flex>
                    )}
                </Flex>
            </Flex>
        )
    }
    _renderEditorState(){
        return (
            <Flex width='100%' className={style.Item} grow basis='180px'>
                <Flex column grow>
                    <Flex className={style.ItemResponseBody} grow>
                        <Flex vAlignContent='center' hAlignContent='center' marginLeft='20px' marginRight='20px'>
                            <img
                                alt=''
                                width='70px'
                                height='70px'
                                src={EmployeeSelector.getImageUrl(this.props.employee)}/>
                        </Flex>
                        <Flex column grow className={style.Info}>
                            <Flex>
                            <Flex basis='50%' hAlignContent='left' className={style.Name} vAlignContent='center' marginTop='20px'>
                                {EmployeeSelector.getName(this.props.employee)}
                            </Flex>
                            <Flex basis='50%' hAlignContent='right' className={style.Name} vAlignContent='center' marginTop='20px'>
                                <SelectInput select={this.state.updates.role}
                                        values={{
                                            admin: 'Admin',
                                            manager: 'Manager',
                                            employee: 'Employee'
                                        }}
                                        onChange={this._changeRole}
                                />
                            </Flex>
                            </Flex>

                            <Flex grow vAlignContent='bottom' className={style.Email} marginBottom='20px'>
                            {EmployeeSelector.email(this.props.employee)}
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>

                <Flex hAlignContent='right' basis='70px'>
                    <Flex className={style.ItemOptions} column vAlignContent='center' hAlignContent='center'>
                            <SVGButton
                            onClick={this._changeView}
                            src='/images/Return.svg'
                            color='darkgrey' hover='blue'
                            />
                            <SVGButton
                            color='darkgrey'
                            hover='blue'
                            src='/images/Save.svg'
                            onClick={this._saveToDatabase}
                            />
                    </Flex>
                </Flex>
            </Flex>
        )
    }
    render(){
        switch(this.state.screen){
            case 'edit':
                return this._renderEditorState()
            case 'normal':
            default:
                return this._renderNormalState(this.state.screen)
        }
    }
}



export default connect()(Item);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Employee/Item.js